import { motion } from "framer-motion";
import { Mail, Phone } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { InquiryForm } from "@/components/site/InquiryForm";

const EMAIL = "info@theblakesmithco.com";
const PHONE_DISPLAY = "(256) 508-0732";
const PHONE_TEL = "+12565080732";

const Action = ({ href, icon: Icon, label, testId }) => (
  <motion.a
    className="contact-pill"
    href={href}
    whileHover={{ y: -3 }}
    whileTap={{ scale: 0.97 }}
    data-testid={testId}
  >
    <Icon size={22} strokeWidth={1.8} aria-hidden="true" />
    <span>{label}</span>
  </motion.a>
);

export const Contact = () => (
  <section id="contact" className="contact" data-testid="contact-section">
    <div className="glow-line glow-top" aria-hidden="true" />
    <div className="contact-glow" aria-hidden="true" />
    <div className="shell contact-inner">
      <Reveal as="h2" className="contact-title">LET’S WORK TOGETHER</Reveal>
      <Reveal as="p" delay={0.1} className="contact-sub">Have a project or idea? Reach out today.</Reveal>
      <Reveal delay={0.2} className="contact-actions">
        <Action href={`mailto:${EMAIL}`} icon={Mail} label={EMAIL} testId="contact-email-link" />
        <Action href={`tel:${PHONE_TEL}`} icon={Phone} label={PHONE_DISPLAY} testId="contact-phone-link" />
      </Reveal>
      <Reveal delay={0.25} className="inquiry-wrap">
        <InquiryForm />
      </Reveal>
    </div>
  </section>
);
